import Main from '../../views/main'
import {ParentView} from '@/ladmin'

export default [
  {
    path: '/messageManagement',
    name: 'messageManagement',
    component: Main,
    meta: {
      disabled: true,
      label: '消息管理'
    },
    children: [
      {
        name: 'messageTemplate',
        path: 'messageTemplate',
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/MessageManagement/messageTemplate/messageTemplate'),
        meta: {
          label: '消息模板',
        },
      },
      {
        name: 'messageTemplateParent',
        props: true,
        redirect: {name: 'messageTemplate'},
        path: 'messageTemplateParent',
        component: ParentView,
        meta: {
          label: '消息模板',
        },
        children: [
          {
            name: 'smsMessageDetail',
            path: 'smsMessageDetail',
            meta: {
              label: '短信模板详情',
              keepAlive: true
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/MessageManagement/messageTemplate/smsMessageDetailBox'),
            /* children: ParentView, */
          },
          {
            name: 'newSmsMessage',
            path: 'newSmsMessage',
            meta: {
              label: '新建短信模板',
              keepAlive: true
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/MessageManagement/messageTemplate/smsMessageDetailBox'),
            /* children: ParentView, */
          }
        ]
      },
      {
        name: 'sendManagement',
        path: 'sendManagement',
        components: {
          default: () => import(/* webpackChunkName: "reservation" */ '@/views/MessageManagement/sendManagement/sendMessage'),
          children: ParentView,
        },
        meta: {
          label: '手动填发',
        },
        children: [
        ]
      },
      {
        name: 'messageLog',
        path: 'messageLog',
        components: {
          default: () => import(/* webpackChunkName: "reservation" */ '@/views/MessageManagement/messageLogList'),
          children: ParentView,
        },
        meta: {
          label: '日志查询',
        },
        children: [
        ]
      },
    ]
  }
]
